<template>
  <div class="account-migrate">
    <div class="container">
      <el-row type="flex" justify="center">
        <el-col :md="24">
          <el-card show type="primary">
            <h2>Migrate Your Exchange Keys</h2>
            <p>
              Use this tool if you had to generate new exchange API keys and you want to link your old data to your new keys.
            </p>
            <p>
              <strong>Important:</strong> Make sure you whitelist our backend IP address 34.233.244.208
            </p>
            <hr>
            <p>
              <strong>Copy the API key to migrate:</strong>
            </p>
            <el-table :data="exchanges" empty-text="No Keys" :highlight-current-row="false" label-width="200px" stripe border>
              <el-table-column label="Dev ID" width="140">
                <template slot-scope="scope">
                  <span>{{ scope.row.id.split('-')[0] }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Exchange" width="140">
                <template slot-scope="scope">
                  <span>{{ scope.row.type }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Created At" width="140">
                <template slot-scope="scope">
                  <span>{{ scope.row.createdAt | toDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="API Key">
                <template slot-scope="scope">
                  <span>{{ scope.row.key }}</span>
                </template>
              </el-table-column>
            </el-table>
            <hr>
            <el-form>
              <el-input v-model="oldKey" type="text" placeholder="12345">
                <template slot="prepend">Old API Key</template>
              </el-input>
              <hr>
              <el-input v-model="newKey" type="text" placeholder="12345">
                <template slot="prepend">New API Key</template>
              </el-input>
              <el-input v-model="newSecret" type="text" placeholder="12345">
                <template slot="prepend">New API Secret</template>
              </el-input>
              <hr>
              <el-row type="flex" justify="end">
                <el-button @click="migrate" type="primary" :loading="loading" :disabled="!oldKey || !newKey || !newSecret">
                  Migrate Keys
                </el-button>
              </el-row>
            </el-form>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import api from '@/lib/api'
import license from '@/lib/license'

export default {
  name: 'AccountMigrate',
  data() {
    return {
      exchanges: [],
      oldKey: '',
      newKey: '',
      newSecret: '',
      loading: false
    }
  },
  filters: {
    toDate(val) {
      return DateTime.fromISO(val).toFormat('MMMM d, yyyy')
    }
  },
  methods: {
    async migrate(event) {
      if (event) event.preventDefault()
      this.loading = true
      try {
        const [exchange] = await api.listExchanges({ key: this.oldKey })
        if (!exchange) {
          this.loading = false
          await this.$alert('We could not find this API key in our system.', 'Something went wrong')
          return
        }

        await api.updateExchange(exchange.id, {
          key: this.newKey,
          secret: this.newSecret
        })

        this.oldKey = ''
        this.newKey = ''
        this.newSecret = ''

        await this.$alert('You\'re API keys have been migrated. Please log out and log back in to PTDefender', 'Migrated')
      } catch(err) {
        await this.$alert('Your new API keys are invalid. Please make sure you whitelisted our backend IP address 34.233.244.208', 'Something went wrong')
      }
      this.loading = false
    }
  },
  async mounted() {
    if (license.requireAuth(this)) return
    this.exchanges = await api.listExchanges()
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';
.account-migrate {
  padding: 150px 8px 200px 8px;

  .el-input {
    margin: 10px auto;
    .el-input-group__prepend {
      width: 85px;
      padding: 0 14px;
    }
  }
}
</style>
